import React from "react";
import PercentageChangeForm from "./components/PercentageChangeForm";
import Footer from "./components/Footer";
import Header from "./components/Header"

function App() {
  return (
    <div>
      <Header/>
      <PercentageChangeForm />
      <Footer/>
    </div>
  );
}

export default App;
